import './NavBarLink.css'
import { NavLink } from 'react-router-dom'
import React, { useEffect, useState } from 'react'

export const NavBarLink = ( { route, onClick } ) => {

    return <NavLink to={route.path} className='NavLink' onClick={onClick}>{route.name}</NavLink>
}
